import { useEffect, useState } from 'react'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import { getSavedPdfFontScale, setPdfFontScale } from '@/lib/fontScale'

const PDF_FONT_SCALE_OPTIONS = [
  { value: '1', label: 'A' },
  { value: '1.2', label: 'A+' },
  { value: '1.4', label: 'A++' },
] as const

type PdfFontSizeSwitchProps = {
  onChange?: (scale: number) => void
}

export const PdfFontSizeSwitch = ({ onChange }: PdfFontSizeSwitchProps) => {
  const [fontScaleValue, setFontScaleValue] = useState('1.2')

  useEffect(() => {
    const saved = getSavedPdfFontScale()
    setFontScaleValue(String(saved))
    onChange?.(saved)
  }, [onChange])

  return (
    <ToggleGroup
      className="rounded-full shadow-2xl px-2 py-1"
      type="single"
      value={fontScaleValue}
      onValueChange={(value) => {
        if (!value) return
        setFontScaleValue(value)
        const next = setPdfFontScale(Number(value))
        onChange?.(next)
      }}
      aria-label="PDF font size"
    >
      {PDF_FONT_SCALE_OPTIONS.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value} aria-label={`PDF font size ${option.label}`}>
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
